import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const SearchEnroll = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const api = process.env.REACT_APP_API;
  const navigate = useNavigate();

  const handleSearch = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("jwt_token");

    if (!token) {
      alert("Login required. Please log in first.");
      setLoading(false);
      return;
    }

    // ✅ Validate mobile number format
    if (!/^\d{10}$/.test(mobileNumber)) {
      setError("Please enter a valid 10-digit mobile number.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${api}/getDetails?mobile=${mobileNumber}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        mode: "cors",
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Error response:", errorText);
        setError(errorText || "No data found or unauthorized.");
        setData([]);
        return;
      }

      const result = await response.json();
      setData(result);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError("Failed to retrieve data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleEnroll = (id) => {
    navigate(`/enquiry-admission/${id}`);
  };

  return (
    <div className="search-enroll-container">
      <div className="search-box">
        <input
          type="tel" // ✅ use tel instead of number or text
          className="input-field"
          placeholder="Enter 10-digit Mobile Number"
          value={mobileNumber}
          onChange={(e) => {
            // ✅ Allow only digits
            const value = e.target.value.replace(/\D/g, '');
            setMobileNumber(value);
          }}
          maxLength="10"
        />
        <button className="get-button" onClick={handleSearch} disabled={loading}>
          {loading ? 'Loading...' : 'Get'}
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {data.length > 0 && (
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Address</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>{item.address}</td>
                <td>
                  {item.status === "joined" ? (
                    <button>Edit</button>
                  ) : (
                    <button onClick={() => handleEnroll(item._id)}>Enroll</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SearchEnroll;
